export default __webpack_public_path__ + "assets/images/button-good.e05cd3ed7e3b3ba0fdff7010470a2384.svg";